import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { appointmentProgressActions } from '../../../redux/appointmentForm/progress-types';
import { selectSchedulingTreeOrganizations } from '../../../redux/appointmentForm/selectors';
import * as myProviders from '../../../redux/appointmentForm/requests/my-providers-req';
import withCareUserSubtitle from '../hocs/withCareUserSubtitle';

const mapStateToProps = state => ({
  organizations: selectSchedulingTreeOrganizations(state),
});
const mapDispatchToProps = {
  myProvidersInit: myProviders.actions.init,
  setActiveOrganization: appointmentProgressActions.setOrganization,
};

export const enhance = compose(
  injectIntl,
  withCareUserSubtitle,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentOrganizations/enhance.js